import styled from 'styled-components';
import { flexFixedSizeItem } from '../../../../themes/architecture/css-helpers/flex';
import {styledByDevice} from '../../../../themes/architecture/styled-by-device';
import { HOME_PAGE } from "../../../../themes/css-global-classes";

/** Export this for Casino 777 box */
export const DefaultBox = styled.div`
    ${flexFixedSizeItem}
    margin: 1rem 1rem 3rem;
    align-self: stretch;
`;

export const PcBox = styled(DefaultBox)`
    width: calc((100% / 5) * 2);

    /**
     * Make it a little bigger on lobby page (slots and jackpots pages for example) because on stage and production there's a banner to the right
     * and because of that the width of the swiper is actually smaller than in localhost or mirage
     */
    .${HOME_PAGE} & {
        width: calc((100% / 6) * 2);
    }

    /**
     * When the paged is scaled down due to html font-size (rem units), make the widget smaller so it won't look like a Goliath.
     * Scale to 90%
     */
    @media ${({theme}) => theme.mediaQuery.xlAndBelow}, ${({theme}) => theme.mediaQuery.lowHeight} {
        .${HOME_PAGE} & {
            width: calc((100% / 6) * 2 * 0.9);
        }
    }
`;

export const MobileBox = styled(DefaultBox)`
    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        width: calc((100% / 6) * 2);
    }

    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
        width: calc(100% / 3);
        margin: 1rem 1.5rem 0;
    }
`;

export const JackpotWidgetDefaultBox = styledByDevice(PcBox, MobileBox);
